import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GroupsService } from '../../../services/groups.service'
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'selection-dialog',
    templateUrl: 'selection.component.html',
  })
  export class SelectionDialog {
   
    groupType;
    groups;
    selectedId;

    constructor(
        public dialogRef: MatDialogRef<SelectionDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: GroupsService,
        public dialog: MatDialog,
        private userService: UserService
        ) {
           

            this.groupType = this.data.groupType;

            /* if(JSON.parse(localStorage.get("user")).groups[this.groupType].length < 2){
                this.dialogRef.close();
            } */

            this.getGroups();

            if(localStorage.getItem(this.groupType)){
                this.selectedId = JSON.parse(localStorage.getItem(this.groupType)).id;
            }

        }

        getGroups () {
            let user = JSON.parse(localStorage.getItem('userS'))
            this.groups = user.groups[this.groupType];
            if( this.groups.length == 1 ){
                this.userService.setActiveGroup(this.groupType, this.groups[0].id);
                //this.service.changeGroup(this.groups[0], this.groupType);
                this.dialogRef.close();
                
            }
        }

        selectGroup(group){
            //localStorage.setItem(this.groupType, JSON.stringify(group));
            this.userService.setActiveGroup(this.groupType, group.id);
            //this.service.changeGroup(group, this.groupType);
        }

        

  }